const SLUG = "outsourced-financial-management";

/**
 * Why there is no price on this page, and what the price actually depends on.
 *
 * Six factors, then the promise that matters commercially: one monthly fee for
 * the whole function, not an invoice per role.
 */
export const FeeFactors = ({ factors }) => (
  <section
    data-testid={`${SLUG}-fee-factors`}
    className="border-y border-border bg-[color:var(--tt-surface-2)] py-14 sm:py-20"
  >
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <h2 className="max-w-[34ch] text-[27px] font-bold leading-[1.15] tracking-[-0.015em] text-foreground sm:text-[34px]">
        Your finance function is scoped around your business
      </h2>
      <p className="mt-4 max-w-[64ch] text-[15px] leading-relaxed text-muted-foreground sm:text-base">
        The monthly fee depends on the finance capacity your business requires. We assess the
        work to be performed, the team required and the level of involvement before
        recommending a structure and a fee.
      </p>

      <dl className="mt-9 grid grid-cols-1 gap-x-10 gap-y-7 sm:grid-cols-2 lg:grid-cols-3">
        {factors.map(({ title, text, icon: Icon }) => (
          <div
            key={title}
            data-testid={`${SLUG}-factor-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
          >
            <dt className="flex items-center gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-[color:var(--tt-accent)] shadow-sm">
                <Icon className="h-4 w-4" aria-hidden="true" />
              </span>
              <span className="text-[12.5px] font-bold uppercase leading-tight tracking-[0.08em] text-foreground">
                {title}
              </span>
            </dt>
            <dd className="mt-3 border-l border-border pl-4 text-[13.5px] leading-relaxed text-muted-foreground">
              {text}
            </dd>
          </div>
        ))}
      </dl>

      <p className="mt-10 max-w-[64ch] rounded-xl border border-[color:var(--tt-teal-line)] bg-white p-5 text-[14.5px] leading-relaxed text-foreground">
        Following the scoping process, you receive{" "}
        <span className="font-semibold">one agreed monthly fee</span> covering the outsourced
        finance function — rather than separate charges for each member of the team.
      </p>
    </div>
  </section>
);
